let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("kTnp0")]).then(() => parcelRequire('10sHA'));